/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S6_BodyInputs */

const en_fc_tut_s6_body = /** @type {(inputs: Fc_Tut_S6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a clip and open its color controls. Start with basic correction (exposure, contrast, temperature), then shape the look with curves, color wheels, HSL secondaries or a LUT. Keep the waveform and vectorscope open so you are grading with data, not guesses.`)
};

/**
* | output |
* | --- |
* | "Select a clip and open its color controls. Start with basic correction (exposure, contrast, temperature), then shape the look with curves, color wheels, HSL ..." |
*
* @param {Fc_Tut_S6_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s6_body = /** @type {((inputs?: Fc_Tut_S6_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S6_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s6_body(inputs)
});
export { fc_tut_s6_body as "fc.tut.s6.body" }